import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let Chart3DAxesDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-chart3daxes';
        }
    }
});
export const Chart3DAxesPlugin = {
    name: 'e-chart3daxes',
    install(Vue) {
        Vue.component(Chart3DAxesPlugin.name, Chart3DAxesDirective);
    }
};
export let Chart3DAxisDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-chart3daxis';
        }
    }
});
export const Chart3DAxisPlugin = {
    name: 'e-chart3daxis',
    install(Vue) {
        Vue.component(Chart3DAxisPlugin.name, Chart3DAxisDirective);
    }
};
